module.exports = __webpack_public_path__ + "assets/xiezizhuo.1e17bd39.svg";